import { hasAvailabilityInStore } from "@components/try-and-buy/components/stores/utils";
import type { StoreHit } from "@components/try-and-buy/types/store";
import type { ReactNode } from "react";
import { useHits, useInstantSearch } from "react-instantsearch";
import { useTryAndBuyContext } from "../context";
import type { ProductVariant } from "@graphql/generated/types";

type Props = {
    selectedVariant: ProductVariant;
    children: ({ isNotAvailable }: { isNotAvailable: boolean; isLoading: boolean }) => ReactNode;
};

export const AvailabilityProvider = ({ children, selectedVariant }: Props) => {
    const { hits } = useHits<StoreHit>();
    const { status } = useInstantSearch();

    const { variants, sku: preselectedSKU } = useTryAndBuyContext();

    const isLoading = status === "loading";

    const skus = variants.map(({ sku }) => sku);

    const storeWithAvailability = hits.find((store) =>
        selectedVariant
            ? hasAvailabilityInStore({
                  variants,
                  selectedSku: preselectedSKU,
                  supplyChannels: store.supplyChannels,
              })
            : skus.find((sku) =>
                  hasAvailabilityInStore({
                      variants,
                      selectedSku: sku,
                      supplyChannels: store.supplyChannels,
                  })
              )
    );

    const isNotAvailable = !Boolean(storeWithAvailability);

    return children({
        isNotAvailable,
        isLoading,
    });
};
